import { z } from 'zod'

/* Admin Device Provisions API */

/**
 * Type for 'DeviceProfileResponse' (backend API data type).
 */
export interface AdminDeviceProfileResponseItem {
  name: string
}

/**
 * Schema for 'DeviceProfileResponse' (backend API data type).
 */
export const AdminDeviceProfileResponseItemSchema = z.object({
  name: z.string()
})

/**
 * Schema for 'DeviceProfileResponse' list response.
 */
export const AdminDeviceProfilesResponse = z.array(AdminDeviceProfileResponseItemSchema)

/**
 * Type for 'TenantResponseDto' (backend API data type).
 */
export interface AdminTenantResponseItem {
  name: string
}

/**
 * Schema for 'TenantResponseDto' (backend API data type).
 */
export const AdminTenantResponseItemSchema = z.object({
  name: z.string()
})

/**
 * Schema for 'TenantResponsDto' list response.
 */
export const AdminTenantsResponse = z.array(AdminTenantResponseItemSchema)

/**
 * Type for 'DeviceForProvisionResponseDto' (backend API data type).
 */
export interface AdminDeviceProvisionsResponseItem {
  id: string
  devEUI: string
  serialNumber: string
  appEUI: string
  appKey: string
  deviceProfileId: string
}

/**
 * Schema for 'DeviceForProvisionResponseDto' (backend API data type).
 */
export const AdminDeviceProvisionsResponseItemSchema = z.object({
  id: z.string(),
  devEUI: z.string(),
  serialNumber: z.string(),
  appEUI: z.string(),
  appKey: z.string(),
  deviceProfileId: z.string()
})

/**
 * Schema for 'DeviceForProvisionResponseDto' list response.
 */
export const AdminDeviceProvisionsResponseSchema = z.array(AdminDeviceProvisionsResponseItemSchema)

/**
 * Type for 'ImportFromCsvResponse' (backend API data type).
 */
export interface AdminDeviceForProvisionCsvImportResponse {
  importedDevices: AdminDeviceProvisionsResponseItem[] | null
  error: string | null
}

/**
 * Schema for 'ImportFromCsvResponse' (backend API data type).
 */
export const AdminDeviceForProvisionCsvImportResponseSchema = z.object({
  importedDevices: z.array(AdminDeviceProvisionsResponseItemSchema).nullable(),
  error: z.string().nullable()
})
